import { ICourseModel } from 'models/course.model'
import { ICourseCard } from 'models/courseCard.model'

export const courseParser = (course: ICourseModel): ICourseCard => ({
  id: course.id,
  courseType: course.courseType,
  description: course.description,
  state: course.state,
  canRestart: course.canRestart,
  thumbnailUrl: course.thumbnailUrl,
  bannerUrl: course.bannerUrl,
  name: course.name,
  mandatory: course.mandatory,
  normative: course.normative,
  synchronousCourse: course.synchronousCourse,
})
